import React from 'react';

import FaLinkedinSquare from 'react-icons/lib/fa/linkedin-square';
import FaGithub from 'react-icons/lib/fa/github';
import FaInstagram from 'react-icons/lib/fa/instagram';

export const SocialLinks = (props) => {
	return (
		<ul className="social-links">
			<Social href="https://www.linkedin.com/in/willchristenson/" title="LinkedIn"><FaLinkedinSquare /></Social>
			<Social href="https://github.com/MrSpecific/" title="Github"><FaGithub /></Social>
			<Social href="https://www.instagram.com/mr_specific/" title="Instagram"><FaInstagram /></Social>
		</ul>
	);
};

const Social = (props) => {
	return <li className="social-link"><a href={props.href} title="LinkedIn" target="_blank" rel="noopener noreferrer">{props.children}</a></li>;
}



// WEBPACK FOOTER //
// ./src/SocialLinks.js